// app/assets/javascripts/application.js

// Import Popper (required for Bootstrap dropdowns)
import * as Popper from '@popperjs/core';
window.Popper = Popper;

// Import Bootstrap Bundle (includes Popper automatically)
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Initialize Bootstrap components
function initializeBootstrapComponents() {
  console.log('Initializing Bootstrap components...');
  
  // Initialize tooltips
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(element => {
    try {
      new bootstrap.Tooltip(element);
    } catch (e) {
      console.error('Tooltip error:', e);
    }
  });
  
  // Initialize popovers
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(element => {
    try {
      new bootstrap.Popover(element);
    } catch (e) {
      console.error('Popover error:', e);
    }
  });
  
  // Dropdowns should auto-initialize with data-bs-toggle="dropdown"
  console.log('Dropdowns found:', document.querySelectorAll('[data-bs-toggle="dropdown"]').length);
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBootstrapComponents);
} else {
  initializeBootstrapComponents();
}

console.log('Teleco.IO app loaded. Bootstrap:', window.bootstrap);
